"use client"
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew"
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos"
import UnfoldLessIcon from "@mui/icons-material/UnfoldLess"
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore"
import { Box, IconButton, Typography, Chip, useTheme, alpha, Paper, useMediaQuery, Tooltip, CircularProgress } from "@mui/material"
import PaidIcon from "@mui/icons-material/Paid"
import InventoryIcon from "@mui/icons-material/Inventory"
import EqualizerIcon from '@mui/icons-material/Equalizer'
import PersonIcon from "@mui/icons-material/Person"
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn"
import AttachMoneyIcon from "@mui/icons-material/AttachMoney"
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet"
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong"
const CustomPagination = ({
  currentPage,
  totalPages,
  totalCount,
  montoTotalTransacciones,
  vieneDe,
  montoTotalSeleccionado = 0,
  cantidadSeleccionada = 0,
  montoFinalCaja = 0,
  mostrarMontoFinal = true,
  totalIngresos = 0,
  totalEgresos = 0,
  onPageChange,
  // tablaRecetas
  totalPrecioTotal = 0,
  totalCostoTotal = 0,
  totalGanancia = 0,
  loadingTotales = false,
  mostrarPrecioOriginal = true,
  totalPasajerosConfirmados = 0,
  // clientePaqueteDetalle
  totalPrecioOriginal = 0,
  totalPrecioActualizado = 0,
  totalAbonado = 0,
  totalSaldo = 0,
  mostrarPrecioOriginalCliente = true,
  mostrarPrecioActualizadoCliente = true,
  mostrarAbonadoCliente = true,
  mostrarSaldoCliente = true,
  // verBalance
  mostrarPrecioOriginalVerBalance = true,
  mostrarPrecioTotalVerBalance = true,
  mostrarCostoTotalVerBalance = true,
  mostrarGananciaVerBalance = true,
  // tablaTransaccion - toggle totales (Referencias, Venta, Ingreso, etc.)
  showFooterSummary = true,
  onToggleFooterSummary,
}) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"))
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"))
  const isMobileOrTablet = isMobile || isTablet
  const safeTotalPages = Math.max(Number(totalPages) || 1, 1)
  const safeCurrentPage = Math.min(Math.max(Number(currentPage) || 1, 1), safeTotalPages)

  // Determinar el icono y texto según el contexto
  const getContextInfo = () => {
    if (vieneDe === "tablaVentas" || vieneDe === "tablaCompras" || vieneDe === "tablaDetalle" || vieneDe === "tablaCompras" || vieneDe == "tablaCaja") {
      return {
        icon: <PaidIcon fontSize="small" sx={{ color: "#4CAF50" }} />,
        label: `$${montoTotalTransacciones?.toLocaleString("es-AR") || "0.00"}`,
        color: "#4CAF50",
        vieneDe: vieneDe == 'tablaVentas' ? "tablaVentas" : null,
      }
    } else if (vieneDe === "tablaGastos") {
      return {
        icon: <AttachMoneyIcon fontSize="small" sx={{ color: "#F44336" }} />,
        label: `$${montoTotalTransacciones?.toLocaleString("es-AR") || "0.00"}`,
        color: "#F44336",
      }
    } else if (vieneDe === "inventaryComponent") {
      return {
        icon: <InventoryIcon fontSize="small" color="primary" />,
        label: `${totalCount} registros`,
        color: theme.palette.primary.main,
      }
    } else if (vieneDe === "tablaEntidades") {
      return {
        icon: <PersonIcon fontSize="small" sx={{ color: "#5b5b5f" }} />,
        label: `${totalCount} entidades`,
        color: "#5b5b5f",
      }
    } else if (vieneDe === "tablaUsuarios") {
      return {
        icon: <PersonIcon fontSize="small" sx={{ color: "#5b5b5f" }} />,
        label: `${totalCount} usuarios`,
        color: "#5b5b5f",
      }
    }
    return null
  }

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat("es-AR", {
      style: "currency",
      currency: "ARS",
      minimumFractionDigits: 2,
    }).format(amount || 0)
  }

  const getTipoTextoCantidad = () => {
    if (vieneDe === "tablaVentas") {
      return "#Registros "
    } else if (vieneDe === "inventaryComponent") {
      return ""
    } else if (vieneDe === "tablaEntidades") {
      return ""
    } else if (vieneDe === "tablaUsuarios") {
      return ""
    } else {
      return "#Registros "
    }
  }

  const contextInfo = getContextInfo()
  const textoCantidad = getTipoTextoCantidad()

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent:
          vieneDe === "tablaCaja" && !isMobileOrTablet
            ? "space-between"
            : isMobileOrTablet
              ? "center"
              : "space-between",
        backgroundColor: alpha(theme.palette.background.paper, 0.95),
        borderTop: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
        padding: isMobileOrTablet ? "8px 4px" : "0px",
        flexDirection: isMobileOrTablet ? "column" : "row",
        gap: isMobileOrTablet ? 1 : 0,
        position: "sticky",
        bottom: 0,
        zIndex: 100,
        boxShadow: isMobileOrTablet ? "0px -2px 8px rgba(0,0,0,0.1)" : "none",
        width: "100%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          gap: 1,
          my: isMobileOrTablet ? 0 : 1,
          justifyContent: isMobileOrTablet ? "center" : "flex-start",
          alignItems: "center",
          flexWrap: "wrap",
          width: isMobileOrTablet ? "100%" : "auto",
          order: isMobileOrTablet ? 2 : 1,
        }}
      >
        {vieneDe != 'inventaryComponent' ? (
          <Chip
            icon={<EqualizerIcon></EqualizerIcon>}
            label={
              <Typography
                variant="body2"
                sx={{
                  fontWeight: 600,
                  color: "black",
                }}
              >
                {textoCantidad} {totalCount}
              </Typography>
            }
            variant="outlined"
            sx={{
              borderColor: "rgb(1,1,1,0.5)",
            }}
          />
        ) : null}

        {(vieneDe == 'inventaryComponent' || vieneDe == 'tablaVentas' || vieneDe == 'tablaDetalle' || vieneDe == 'tablaCompras' || vieneDe == 'tablaEntidades' || vieneDe == 'tablaUsuarios') && contextInfo ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              gap: 1,
              flexWrap: "wrap",
            }}
          >
            <Chip
              label={
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: 600,
                    color: contextInfo.color,
                    fontSize: isMobileOrTablet ? "0.7rem" : "0.875rem",
                  }}
                >
                  {contextInfo.label}
                </Typography>
              }
              variant="outlined"
              sx={{
                borderColor: alpha(contextInfo.color, 0.5),
                backgroundColor: alpha(contextInfo.color, 0.05),
                marginLeft: isMobileOrTablet ? 0 : (contextInfo.vieneDe == 'tablaVentas' ? 0 : '140px'),
              }}
            />
          </Box>
        ) : null}
        


        {/* Información contextual (monto total o contador) */}

      </Box>

      {(vieneDe == 'tablaCaja') ? (
          <Box
            sx={{
              display: "flex",
              gap: 1,
              justifyContent: isMobileOrTablet ? "center" : "center",
              alignItems: "center",
              width: isMobileOrTablet ? "100%" : "auto",
              order: isMobileOrTablet ? 3 : 2,
              my: isMobileOrTablet ? 0 : 1,
              flexWrap: "wrap",
            }}
          >
            <Tooltip title="Total de todas las páginas" arrow>
              <Paper
                sx={{
                  p: 1,
                  borderRadius: 2,
                  backgroundColor: "#4CAF50",
                  color: "white",
                  minWidth: isMobileOrTablet ? 140 : 180,
                  textAlign: "center",
                  boxShadow: "0px 4px 12px rgba(76, 175, 80, 0.3)",
                  cursor: "help",
                  transition: "transform 0.2s",
                  "&:hover": { transform: "translateY(-2px)" },
                }}
              >
                <Typography variant="body2" sx={{ fontWeight: "bold", mb: 1, fontSize: isMobileOrTablet ? "0.7rem" : "0.875rem" }}>
                  Ingreso Total:
                </Typography>
                <Typography variant={isMobileOrTablet ? "body1" : "h6"} sx={{ fontWeight: "bold", fontSize: isMobileOrTablet ? "0.875rem" : "1.25rem" }}>
                  {formatCurrency(totalIngresos)}
                </Typography>
              </Paper>
            </Tooltip>

            <Tooltip title="Total de todas las páginas" arrow>
              <Paper
                sx={{
                  p: 1,
                  borderRadius: 2,
                  backgroundColor: "#f44336",
                  color: "white",
                  minWidth: isMobileOrTablet ? 140 : 180,
                  textAlign: "center",
                  boxShadow: "0px 4px 12px rgba(244, 67, 54, 0.3)",
                  cursor: "help",
                  transition: "transform 0.2s",
                  "&:hover": { transform: "translateY(-2px)" },
                }}
              >
                <Typography variant="body2" sx={{ fontWeight: "bold", mb: 1, fontSize: isMobileOrTablet ? "0.7rem" : "0.875rem" }}>
                  Egreso Total:
                </Typography>
                <Typography variant={isMobileOrTablet ? "body1" : "h6"} sx={{ fontWeight: "bold", fontSize: isMobileOrTablet ? "0.875rem" : "1.25rem" }}>
                  {formatCurrency(totalEgresos)}
                </Typography>
              </Paper>
            </Tooltip>

            <Tooltip title="Total de todas las páginas" arrow>
              <Paper
                sx={{
                  p: 1,
                  borderRadius: 2,
                  backgroundColor: "#5b5b5f",
                  color: "white",
                  minWidth: isMobileOrTablet ? 140 : 180,
                  textAlign: "center",
                  boxShadow: "0px 4px 12px rgba(244, 177, 14, 0.3)",
                  cursor: "help",
                  transition: "transform 0.2s",
                  "&:hover": { transform: "translateY(-2px)" },
                }}
              >
                <Typography variant="body2" sx={{ fontWeight: "bold", mb: 1, fontSize: isMobileOrTablet ? "0.7rem" : "0.875rem" }}>
                  Monto Neto:
                </Typography>
                <Typography variant={isMobileOrTablet ? "body1" : "h6"} sx={{ fontWeight: "bold", fontSize: isMobileOrTablet ? "0.875rem" : "1.25rem" }}>
                  {contextInfo?.label || "$0,00"}
                </Typography>
              </Paper>
            </Tooltip>

            {mostrarMontoFinal && (
              <Tooltip title="Total de todas las páginas" arrow>
                <Paper
                  sx={{
                    p: 1,
                    borderRadius: 2,
                    backgroundColor: "#5b5b5f",
                    color: "white",
                    minWidth: isMobileOrTablet ? 140 : 180,
                    textAlign: "center",
                    boxShadow: "0px 4px 12px rgba(244, 177, 14, 0.3)",
                    cursor: "help",
                    transition: "transform 0.2s",
                    "&:hover": { transform: "translateY(-2px)" },
                  }}
                >
                  <Typography variant="body2" sx={{ fontWeight: "bold", mb: 1, fontSize: isMobileOrTablet ? "0.7rem" : "0.875rem" }}>
                    Monto Final:
                  </Typography>
                  <Typography variant={isMobileOrTablet ? "body1" : "h6"} sx={{ fontWeight: "bold", fontSize: isMobileOrTablet ? "0.875rem" : "1.25rem" }}>
                    {formatCurrency(montoFinalCaja)}
                  </Typography>
                </Paper>
              </Tooltip>
            )}
          </Box>

        ) : null}

      {/* 🔧 BLOQUES DE TOTALES PARA TABLA RECETAS */}
      {vieneDe === "tablaRecetas" && (
        <Box sx={{ 
          display: "flex", 
          gap: 1.5, 
          justifyContent: "center", 
          alignItems: "center", 
          flex: 1,
          order: isMobileOrTablet ? 3 : 2,
          my: isMobileOrTablet ? 0 : 1,
          flexWrap: "wrap",
        }}>
          {/* Bloque 0: Precio Original - condicionado por mostrarPrecioOriginal */}
          {mostrarPrecioOriginal && (
            <Paper
              sx={{
                p: 1,
                borderRadius: 2,
                backgroundColor: alpha("#1976d2", 0.1),
                border: `2px solid ${alpha("#1976d2", 0.3)}`,
                minWidth: 150,
                textAlign: "center",
                boxShadow: "0px 2px 8px rgba(25, 118, 210, 0.2)",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 0.5, mb: 0.5 }}>
                <Typography variant="body2" sx={{ fontWeight: 600, color: "#1976d2" }}>
                  Precio Original
                </Typography>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1 }}>
                {loadingTotales ? (
                  <CircularProgress size={20} sx={{ color: "#1976d2" }} />
                ) : (
                  <Typography variant="h6" sx={{ fontWeight: 700, color: "#1976d2" }}>
                    {formatCurrency(totalPrecioOriginal)}
                  </Typography>
                )}
              </Box>
            </Paper>
          )}

          <Paper
            sx={{
              p: 1,
              borderRadius: 2,
              backgroundColor: alpha("#7b1fa2", 0.1),
              border: `2px solid ${alpha("#7b1fa2", 0.3)}`,
              minWidth: 150,
              textAlign: "center",
              boxShadow: "0px 2px 8px rgba(123, 31, 162, 0.2)",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 0.5, mb: 0.5 }}>
              <Typography variant="body2" sx={{ fontWeight: 600, color: "#7b1fa2" }}>
                Pasajeros Totales
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1 }}>
              {loadingTotales ? (
                <CircularProgress size={20} sx={{ color: "#7b1fa2" }} />
              ) : (
                <Typography variant="h6" sx={{ fontWeight: 700, color: "#7b1fa2" }}>
                  {Number(totalPasajerosConfirmados || 0).toLocaleString("es-AR")}
                </Typography>
              )}
            </Box>
          </Paper>

          {vieneDe !== "tablaRecetas" && (
            <>
              {/* Bloque 1: Precio Total */}
              <Paper
                sx={{
                  p: 1,
                  borderRadius: 2,
                  backgroundColor: alpha("#4CAF50", 0.1),
                  border: `2px solid ${alpha("#4CAF50", 0.3)}`,
                  minWidth: 150,
                  textAlign: "center",
                  boxShadow: "0px 2px 8px rgba(76, 175, 80, 0.2)",
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 0.5, mb: 0.5 }}>
                  <MonetizationOnIcon fontSize="small" sx={{ color: "#4CAF50" }} />
                  <Typography variant="body2" sx={{ fontWeight: 600, color: "#4CAF50" }}>
                    Precio Total
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1 }}>
                  {loadingTotales ? (
                    <CircularProgress size={20} sx={{ color: "#4CAF50" }} />
                  ) : (
                    <Typography variant="h6" sx={{ fontWeight: 700, color: "#4CAF50" }}>
                      {formatCurrency(totalPrecioTotal)}
                    </Typography>
                  )}
                </Box>
              </Paper>

              {/* Bloque 2: Costo Total */}
              <Paper
                sx={{
                  p: 1,
                  borderRadius: 2,
                  backgroundColor: alpha("#FF8042", 0.1),
                  border: `2px solid ${alpha("#FF8042", 0.3)}`,
                  minWidth: 150,
                  textAlign: "center",
                  boxShadow: "0px 2px 8px rgba(255, 128, 66, 0.2)",
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 0.5, mb: 0.5 }}>
                  <AttachMoneyIcon fontSize="small" sx={{ color: "#FF8042" }} />
                  <Typography variant="body2" sx={{ fontWeight: 600, color: "#FF8042" }}>
                    Costo Total
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1 }}>
                  {loadingTotales ? (
                    <CircularProgress size={20} sx={{ color: "#FF8042" }} />
                  ) : (
                    <Typography variant="h6" sx={{ fontWeight: 700, color: "#FF8042" }}>
                      {formatCurrency(totalCostoTotal)}
                    </Typography>
                  )}
                </Box>
              </Paper>

              {/* Bloque 3: Ganancia */}
              <Paper
                sx={{
                  p: 1,
                  borderRadius: 2,
                  backgroundColor: totalGanancia >= 0
                    ? alpha("#0088FE", 0.1)
                    : alpha("#F44336", 0.1),
                  border: `2px solid ${totalGanancia >= 0
                    ? alpha("#0088FE", 0.3)
                    : alpha("#F44336", 0.3)}`,
                  minWidth: 150,
                  textAlign: "center",
                  boxShadow: totalGanancia >= 0
                    ? "0px 2px 8px rgba(0, 136, 254, 0.2)"
                    : "0px 2px 8px rgba(244, 67, 54, 0.2)",
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 0.5, mb: 0.5 }}>
                  <AccountBalanceWalletIcon fontSize="small" sx={{ color: totalGanancia >= 0 ? "#0088FE" : "#F44336" }} />
                  <Typography variant="body2" sx={{ fontWeight: 600, color: totalGanancia >= 0 ? "#0088FE" : "#F44336" }}>
                    Ganancia
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1 }}>
                  {loadingTotales ? (
                    <CircularProgress size={20} sx={{ color: totalGanancia >= 0 ? "#0088FE" : "#F44336" }} />
                  ) : (
                    <Typography variant="h6" sx={{ fontWeight: 700, color: totalGanancia >= 0 ? "#0088FE" : "#F44336" }}>
                      {formatCurrency(totalGanancia)}
                    </Typography>
                  )}
                </Box>
              </Paper>
            </>
          )}
        </Box>
      )}

      {/* 🔧 BLOQUES DE TOTALES PARA VER BALANCE */}
      {vieneDe === "verBalance" && (mostrarPrecioOriginalVerBalance || mostrarPrecioTotalVerBalance || mostrarCostoTotalVerBalance || mostrarGananciaVerBalance) && (
        <Box sx={{ 
          display: "flex", 
          gap: 1.5, 
          justifyContent: "center", 
          alignItems: "center", 
          flex: 1,
          order: isMobileOrTablet ? 3 : 2,
          my: isMobileOrTablet ? 0 : 1,
          flexWrap: "wrap",
        }}>
          {mostrarPrecioOriginalVerBalance && (
          <Paper
            sx={{
              p: 1,
              borderRadius: 2,
              backgroundColor: alpha("#1976d2", 0.1),
              border: `2px solid ${alpha("#1976d2", 0.3)}`,
              minWidth: 150,
              textAlign: "center",
              boxShadow: "0px 2px 8px rgba(25, 118, 210, 0.2)",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 0.5, mb: 0.5 }}>
              <Typography variant="body2" sx={{ fontWeight: 600, color: "#1976d2" }}>
                Precio Original
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1 }}>
              {loadingTotales ? (
                <CircularProgress size={20} sx={{ color: "#1976d2" }} />
              ) : (
                <Typography variant="h6" sx={{ fontWeight: 700, color: "#1976d2" }}>
                  {formatCurrency(totalPrecioOriginal)}
                </Typography>
              )}
            </Box>
          </Paper>
          )}

          {mostrarPrecioTotalVerBalance && (
          <Paper
            sx={{
              p: 1,
              borderRadius: 2,
              backgroundColor: alpha("#4CAF50", 0.1),
              border: `2px solid ${alpha("#4CAF50", 0.3)}`,
              minWidth: 150,
              textAlign: "center",
              boxShadow: "0px 2px 8px rgba(76, 175, 80, 0.2)",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 0.5, mb: 0.5 }}>
              <MonetizationOnIcon fontSize="small" sx={{ color: "#4CAF50" }} />
              <Typography variant="body2" sx={{ fontWeight: 600, color: "#4CAF50" }}>
                Precio Total
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1 }}>
              {loadingTotales ? (
                <CircularProgress size={20} sx={{ color: "#4CAF50" }} />
              ) : (
                <Typography variant="h6" sx={{ fontWeight: 700, color: "#4CAF50" }}>
                  {formatCurrency(totalPrecioTotal)}
                </Typography>
              )}
            </Box>
          </Paper>
          )}

          {mostrarCostoTotalVerBalance && (
          <Paper
            sx={{
              p: 1,
              borderRadius: 2,
              backgroundColor: alpha("#FF8042", 0.1),
              border: `2px solid ${alpha("#FF8042", 0.3)}`,
              minWidth: 150,
              textAlign: "center",
              boxShadow: "0px 2px 8px rgba(255, 128, 66, 0.2)",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 0.5, mb: 0.5 }}>
              <AttachMoneyIcon fontSize="small" sx={{ color: "#FF8042" }} />
              <Typography variant="body2" sx={{ fontWeight: 600, color: "#FF8042" }}>
                Costo Total
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1 }}>
              {loadingTotales ? (
                <CircularProgress size={20} sx={{ color: "#FF8042" }} />
              ) : (
                <Typography variant="h6" sx={{ fontWeight: 700, color: "#FF8042" }}>
                  {formatCurrency(totalCostoTotal)}
                </Typography>
              )}
            </Box>
          </Paper>
          )}

          {mostrarGananciaVerBalance && (
          <Paper
            sx={{
              p: 1,
              borderRadius: 2,
              backgroundColor: totalGanancia >= 0
                ? alpha("#0088FE", 0.1)
                : alpha("#F44336", 0.1),
              border: `2px solid ${totalGanancia >= 0
                ? alpha("#0088FE", 0.3)
                : alpha("#F44336", 0.3)}`,
              minWidth: 150,
              textAlign: "center",
              boxShadow: totalGanancia >= 0
                ? "0px 2px 8px rgba(0, 136, 254, 0.2)"
                : "0px 2px 8px rgba(244, 67, 54, 0.2)",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 0.5, mb: 0.5 }}>
              <AccountBalanceWalletIcon fontSize="small" sx={{ color: totalGanancia >= 0 ? "#0088FE" : "#F44336" }} />
              <Typography variant="body2" sx={{ fontWeight: 600, color: totalGanancia >= 0 ? "#0088FE" : "#F44336" }}>
                Ganancia
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1 }}>
              {loadingTotales ? (
                <CircularProgress size={20} sx={{ color: totalGanancia >= 0 ? "#0088FE" : "#F44336" }} />
              ) : (
                <Typography variant="h6" sx={{ fontWeight: 700, color: totalGanancia >= 0 ? "#0088FE" : "#F44336" }}>
                  {formatCurrency(totalGanancia)}
                </Typography>
              )}
            </Box>
          </Paper>
          )}
        </Box>
      )}

      {/* 🔧 BLOQUES DE TOTALES PARA CLIENTE PAQUETE DETALLE */}
      {vieneDe === "clientePaqueteDetalle" && (mostrarPrecioOriginalCliente || mostrarPrecioActualizadoCliente || mostrarAbonadoCliente || mostrarSaldoCliente) && (
        <Box sx={{ 
          display: "flex", 
          gap: 1.5, 
          justifyContent: "center", 
          alignItems: "center", 
          flex: 1,
          order: isMobileOrTablet ? 3 : 2,
          my: isMobileOrTablet ? 0 : 1,
          flexWrap: "wrap",
        }}>
          {mostrarPrecioOriginalCliente && (
            <Paper
              sx={{
                p: 1,
                borderRadius: 2,
                backgroundColor: alpha("#718096", 0.1),
                border: `2px solid ${alpha("#718096", 0.3)}`,
                minWidth: 150,
                textAlign: "center",
                boxShadow: "0px 2px 8px rgba(113, 128, 150, 0.2)",
              }}
            >
               <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", mb: 0.5 }}>
                <Typography variant="body2" sx={{ fontWeight: 600, color: "#718096" }}>
                  Precio Original
                </Typography>
              </Box>
              <Typography variant="h6" sx={{ fontWeight: 700, color: "#718096" }}>
                {formatCurrency(totalPrecioOriginal)}
              </Typography>
            </Paper>
          )}

          {mostrarPrecioActualizadoCliente && (
            <Paper
              sx={{
                p: 1,
                borderRadius: 2,
                backgroundColor: alpha("#4CAF50", 0.1),
                border: `2px solid ${alpha("#4CAF50", 0.3)}`,
                minWidth: 150,
                textAlign: "center",
                boxShadow: "0px 2px 8px rgba(76, 175, 80, 0.2)",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", mb: 0.5 }}>
                <Typography variant="body2" sx={{ fontWeight: 600, color: "#4CAF50" }}>
                  Precio Actualizado
                </Typography>
              </Box>
              <Typography variant="h6" sx={{ fontWeight: 700, color: "#4CAF50" }}>
                {formatCurrency(totalPrecioActualizado)}
              </Typography>
            </Paper>
          )}

          {mostrarAbonadoCliente && (
            <Paper
              sx={{
                p: 1,
                borderRadius: 2,
                backgroundColor: alpha("#0088FE", 0.1),
                border: `2px solid ${alpha("#0088FE", 0.3)}`,
                minWidth: 150,
                textAlign: "center",
                boxShadow: "0px 2px 8px rgba(0, 136, 254, 0.2)",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", mb: 0.5 }}>
                <Typography variant="body2" sx={{ fontWeight: 600, color: "#0088FE" }}>
                  Abonado
                </Typography>
              </Box>
              <Typography variant="h6" sx={{ fontWeight: 700, color: "#0088FE" }}>
                {formatCurrency(totalAbonado)}
              </Typography>
            </Paper>
          )}

          {mostrarSaldoCliente && (
            <Paper
              sx={{
                p: 1,
                borderRadius: 2,
                backgroundColor: totalSaldo > 0 
                  ? alpha("#FF8042", 0.1) 
                  : alpha("#4CAF50", 0.1),
                border: `2px solid ${totalSaldo > 0 
                  ? alpha("#FF8042", 0.3) 
                  : alpha("#4CAF50", 0.3)}`,
                minWidth: 150,
                textAlign: "center",
                boxShadow: totalSaldo > 0
                  ? "0px 2px 8px rgba(255, 128, 66, 0.2)"
                  : "0px 2px 8px rgba(76, 175, 80, 0.2)",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", mb: 0.5 }}>
                <Typography variant="body2" sx={{ fontWeight: 600, color: totalSaldo > 0 ? "#FF8042" : "#4CAF50" }}>
                  Saldo
                </Typography>
              </Box>
              <Typography variant="h6" sx={{ fontWeight: 700, color: totalSaldo > 0 ? "#FF8042" : "#4CAF50" }}>
                {formatCurrency(totalSaldo)}
              </Typography>
            </Paper>
          )}
        </Box>
      )}

      {vieneDe === "tablaGastos" && (
        <Box sx={{ 
          display: "flex", 
          gap: 1.5, 
          justifyContent: "center", 
          alignItems: "center", 
          flex: 1,
          order: isMobileOrTablet ? 3 : 2,
          my: isMobileOrTablet ? 0 : 1,
        }}>
          <Paper
            sx={{
              p: 1,
              borderRadius: 2,
              backgroundColor: alpha("#F44336", 0.1),
              border: `2px solid ${alpha("#F44336", 0.3)}`,
              minWidth: 170,
              textAlign: "center",
              boxShadow: "0px 2px 8px rgba(244, 67, 54, 0.2)",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 0.5, mb: 0.5 }}> 
              <Typography variant="body2" sx={{ fontWeight: 600, color: "#F44336" }}>
                Gasto total
              </Typography>
            </Box>
            <Typography variant="h6" sx={{ fontWeight: 700, color: "#F44336" }}>
              {formatCurrency(montoTotalTransacciones)}
            </Typography>
          </Paper>
        </Box>
      )}

      {/* Toggle totales - centro (entre Registros y paginación) - solo tablaTransaccion */}
      {vieneDe === "tablaTransaccion" && onToggleFooterSummary && (
        <Box
          sx={{
            display: "flex",
            flex: 1,
            justifyContent: "center",
            alignItems: "center",
            order: isMobileOrTablet ? 2 : 2,
            my: isMobileOrTablet ? 0 : 1,
          }}
        >
          <Tooltip title={showFooterSummary ? "Ocultar totales (Referencias, Venta, Ingreso, etc.)" : "Mostrar totales"}>
            <IconButton
              onClick={onToggleFooterSummary}
              size="small"
              sx={{
                color: "primary.main",
                backgroundColor: !showFooterSummary ? alpha(theme.palette.primary.main, 0.1) : "transparent",
                "&:hover": {
                  backgroundColor: alpha(theme.palette.primary.main, 0.2),
                },
                padding: isMobileOrTablet ? "4px" : "8px",
              }}
            >
              {showFooterSummary ? <UnfoldLessIcon fontSize="small" /> : <UnfoldMoreIcon fontSize="small" />}
            </IconButton>
          </Tooltip>
        </Box>
      )}

      {/* Controles de paginación */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: isMobileOrTablet ? 0.5 : 1.5,
          justifyContent: isMobileOrTablet ? "center" : "flex-end",
          width: isMobileOrTablet ? "100%" : "auto",
          order: isMobileOrTablet ? 1 : (vieneDe === "tablaRecetas" || vieneDe === "clientePaqueteDetalle" ? 3 : vieneDe === "tablaTransaccion" ? 3 : 2),
          my: isMobileOrTablet ? 0 : 1,
        }}
      >
        {vieneDe === 'tablaVentas' && cantidadSeleccionada > 0 && (
          <Tooltip title={`Total a facturar de ${cantidadSeleccionada} transacción(es) seleccionada(s)`} arrow>
            <Chip
              icon={<ReceiptLongIcon fontSize="small" />}
              label={
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: 600,
                    color: "#f59e0b",
                    fontSize: isMobileOrTablet ? "0.7rem" : "0.875rem",
                  }}
                >
                  A facturar: {formatCurrency(montoTotalSeleccionado)}
                </Typography>
              }
              variant="outlined"
              sx={{
                borderColor: alpha("#f59e0b", 0.6),
                backgroundColor: alpha("#f59e0b", 0.08),
              }}
            />
          </Tooltip>
        )}
        <IconButton
          onClick={() => onPageChange(safeCurrentPage - 1)}
          disabled={safeCurrentPage === 1}
          size="small"
          sx={{
            color: safeCurrentPage === 1 ? "text.disabled" : "primary.main",
            backgroundColor:
              safeCurrentPage === 1
                ? "transparent"
                : alpha(theme.palette.primary.main, 0.1),
            "&:hover": {
              backgroundColor:
                safeCurrentPage === 1
                  ? "transparent"
                  : alpha(theme.palette.primary.main, 0.2),
            },
            padding: isMobileOrTablet ? "4px" : "8px",
          }}
        >
          <ArrowBackIosNewIcon fontSize="small" />
        </IconButton>

        <Typography
          variant="body2"
          sx={{
            fontWeight: 500,
            fontSize: isMobileOrTablet ? "0.75rem" : "0.875rem",
            px: isMobileOrTablet ? 0.5 : 1,
            textAlign: "center",
            minWidth: isMobileOrTablet ? "80px" : "auto",
          }}
        >
          {isMobileOrTablet
            ? `${safeCurrentPage}/${safeTotalPages}`
            : `Página ${safeCurrentPage} de ${safeTotalPages}`}
        </Typography>

        <IconButton
          onClick={() => onPageChange(safeCurrentPage + 1)}
          disabled={safeCurrentPage === safeTotalPages}
          size="small"
          sx={{
            color:
              safeCurrentPage === safeTotalPages ? "text.disabled" : "primary.main",
            backgroundColor:
              safeCurrentPage === safeTotalPages
                ? "transparent"
                : alpha(theme.palette.primary.main, 0.1),
            "&:hover": {
              backgroundColor:
                safeCurrentPage === safeTotalPages
                  ? "transparent"
                  : alpha(theme.palette.primary.main, 0.2),
            },
            padding: isMobileOrTablet ? "4px" : "8px",
          }}
        >
          <ArrowForwardIosIcon fontSize="small" />
        </IconButton>
      </Box>
    </Box>
  );
}

export default CustomPagination
